import React from 'react'

function Service() {
  return (
    <>
      <div className="service-section">
        <div className="container w-container">
          <div className="service-title-block-wrapper">
            <div className="service-title-block-inner">
              <div className="section-title-block">
                <div className="section-intro-block">Our SERVICES</div>
                <h2 className="section-title">
                  We have the experience to make of your Video
                </h2>
              </div>
            </div>
            <div className="service-button-block">
              <div className="slider-button-block">
                <a href="service-page" className="button-primary slider-button w-inline-block">
                  <div className="button-text">All Services</div>
                  <div className="button-arrow-icon w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15" fill="none">
                      <path id="Vector"
                        d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                        fill="currentColor" />
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div data-delay="4000" data-animation="slide" className="service-slider-wrapper w-slider" data-autoplay="false"
            data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0"
            data-nav-spacing="3" data-duration="500" data-infinite="true">
            <div className="service-slider-mask w-slider-mask">
              <div className="service-slider-item w-slide">
                <div className="service-slider-single-item">
                  <div className="service-slider-single-collection w-dyn-list">
                    <div role="list" className="service-slider-single-list w-dyn-items">
                      <div role="listitem" className="service-slider-single-list-item w-dyn-item">
                        <div className="service-slider-single-wrapper">
                          <div className="service-slider-single-icon-block">
                            <img alt="Service Slider Single Icon" loading="lazy"
                              src="https://assets.website-files.com/63f1bfe469cfc0a7a042f1e8/63f1daa948a58b7456ac7098_photography-icon.svg"
                              className="service-slider-single-icon" />
                          </div>
                          <div className="service-slider-single-content">
                            <a href="" className="service-slider-single-link-block w-inline-block">
                              <h3 className="service-slider-single-title">
                                Engaging Video Production
                              </h3>
                            </a>
                            <p className="service-slider-single-summary">
                              We create captivating video content for a variety of purposes, including marketing, social media, tutorials, and more. Our team of experienced videographers and editors ensures that your message comes to life through the power of video.

                            </p>
                          </div>
                          <a href="" className="service-slider-single-link w-inline-block">
                            <div className="service-slider-single-link-text">
                              Read More
                            </div>
                            <div className="button-arrow-icon w-embed">
                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15"
                                fill="none">
                                <path id="Vector"
                                  d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                                  fill="currentColor" />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="service-slider-item w-slide">
                <div className="service-slider-single-item">
                  <div className="service-slider-single-collection w-dyn-list">
                    <div role="list" className="service-slider-single-list w-dyn-items">
                      <div role="listitem" className="service-slider-single-list-item w-dyn-item">
                        <div className="service-slider-single-wrapper">
                          <div className="service-slider-single-icon-block">
                            <img alt="Service Slider Single Icon" loading="lazy"
                              src="https://assets.website-files.com/63f1bfe469cfc0a7a042f1e8/63f1c319e1e45a596d48347a_videography-icon.svg"
                              className="service-slider-single-icon" />
                          </div>
                          <div className="service-slider-single-content">
                            <a href="" className="service-slider-single-link-block w-inline-block">
                              <h3 className="service-slider-single-title">
                                Creative Storytelling
                              </h3>
                            </a>
                            <p className="service-slider-single-summary">
                              We specialize in telling your unique story through visual narratives. From concept development to post-production, we're dedicated to crafting compelling videos that resonate with your audience.

                            </p>
                          </div>
                          <a href="#" className="service-slider-single-link w-inline-block">
                            <div className="service-slider-single-link-text">
                              Read More
                            </div>
                            <div className="button-arrow-icon w-embed">
                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15"
                                fill="none">
                                <path id="Vector"
                                  d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                                  fill="currentColor" />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="service-slider-item w-slide">
                <div className="service-slider-single-item">
                  <div className="service-slider-single-collection w-dyn-list">
                    <div role="list" className="service-slider-single-list w-dyn-items">
                      <div role="listitem" className="service-slider-single-list-item w-dyn-item">
                        <div className="service-slider-single-wrapper">
                          <div className="service-slider-single-icon-block">
                            <img alt="Service Slider Single Icon" loading="lazy"
                              src="https://assets.website-files.com/63f1bfe469cfc0a7a042f1e8/63f1daf185872a517688f046_aerial-photography-icon.svg"
                              className="service-slider-single-icon" />
                          </div>
                          <div className="service-slider-single-content">
                            <a href=""
                              className="service-slider-single-link-block w-inline-block">
                              <h3 className="service-slider-single-title">
                                High-Quality Editing
                              </h3>
                            </a>
                            <p className="service-slider-single-summary">
                              Our video editing team ensures a polished final product that aligns with your brand's style. We pay close attention to details, transitions, and visual effects to enhance the overall viewer experience.

                            </p>
                          </div>
                          <a href="#" className="service-slider-single-link w-inline-block">
                            <div className="service-slider-single-link-text">
                              Read More
                            </div>
                            <div className="button-arrow-icon w-embed">
                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15"
                                fill="none">
                                <path id="Vector"
                                  d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                                  fill="currentColor" />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="service-slider-item w-slide">
                <div className="service-slider-single-item">
                  <div className="service-slider-single-collection w-dyn-list">
                    <div role="list" className="service-slider-single-list w-dyn-items">
                      <div role="listitem" className="service-slider-single-list-item w-dyn-item">
                        <div className="service-slider-single-wrapper">
                          <div className="service-slider-single-icon-block">
                            <img alt="Service Slider Single Icon" loading="lazy"
                              src="https://assets.website-files.com/63f1bfe469cfc0a7a042f1e8/63fd9ad206354fe39e47c644_icon.svg"
                              className="service-slider-single-icon" />
                          </div>
                          <div className="service-slider-single-content">
                            <a href="" className="service-slider-single-link-block w-inline-block">
                              <h3 className="service-slider-single-title">
                                Customized Video Solutions
                              </h3>
                            </a>
                            <p className="service-slider-single-summary">
                              Whether you need corporate videos, product showcases, event coverage, or any other video content, we tailor our services to meet your specific requirements.
                            </p>
                          </div>
                          <a href="#" className="service-slider-single-link w-inline-block">
                            <div className="service-slider-single-link-text">
                              Read More
                            </div>
                            <div className="button-arrow-icon w-embed">
                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15"
                                fill="none">
                                <path id="Vector"
                                  d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                                  fill="currentColor" />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="service-slider-item w-slide">
                <div className="service-slider-single-item">
                  <div className="service-slider-single-collection w-dyn-list">
                    <div role="list" className="service-slider-single-list w-dyn-items">
                      <div role="listitem" className="service-slider-single-list-item w-dyn-item">
                        <div className="service-slider-single-wrapper">
                          <div className="service-slider-single-icon-block">
                            <img alt="Service Slider Single Icon" loading="lazy"
                              src="https://assets.website-files.com/63f1bfe469cfc0a7a042f1e8/63fd9ae740d99eac08cbac16_icon-1.svg"
                              className="service-slider-single-icon" />
                          </div>
                          <div className="service-slider-single-content">
                            <a href=""
                              className="service-slider-single-link-block w-inline-block">
                              <h3 className="service-slider-single-title">
                                Multi-Platform Optimization
                              </h3>
                            </a>
                            <p className="service-slider-single-summary">
                              We format videos to fit various social media platforms, ensuring your content looks stunning on YouTube, Instagram, Facebook, and more.

                            </p>
                          </div>
                          <a href="#" className="service-slider-single-link w-inline-block">
                            <div className="service-slider-single-link-text">
                              Read More
                            </div>
                            <div className="button-arrow-icon w-embed">
                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15"
                                fill="none">
                                <path id="Vector"
                                  d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                                  fill="currentColor" />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="service-slider-item w-slide">
                <div className="service-slider-single-item">
                  <div className="service-slider-single-collection w-dyn-list">
                    <div role="list" className="service-slider-single-list w-dyn-items">
                      <div role="listitem" className="service-slider-single-list-item w-dyn-item">
                        <div className="service-slider-single-wrapper">
                          <div className="service-slider-single-icon-block">
                            <img alt="Service Slider Single Icon" loading="lazy"
                              src="https://assets.website-files.com/63f1bfe469cfc0a7a042f1e8/63fd9b01710e646421793795_icon-2.svg"
                              className="service-slider-single-icon" />
                          </div>
                          <div className="service-slider-single-content">
                            <a href="service/snapshot-studios"
                              className="service-slider-single-link-block w-inline-block">
                              <h3 className="service-slider-single-title">
                                Professional Photography
                              </h3>
                            </a>
                            <p className="service-slider-single-summary">
                              Our photography services encompass a wide range of styles, including portrait, landscape, product, and event photography. We capture the essence of your subject with an artistic and professional touch.

                            </p>
                          </div>
                          <a href="#" className="service-slider-single-link w-inline-block">
                            <div className="service-slider-single-link-text">
                              Read More
                            </div>
                            <div className="button-arrow-icon w-embed">
                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15"
                                fill="none">
                                <path id="Vector"
                                  d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                                  fill="currentColor" />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="slider-arrow arrow-left w-slider-arrow-left">
              <div className="button-arrow-icon w-embed">
                <svg width="24" height="22" viewBox="0 0 24 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path id="Vector"
                    d="M23.7023 11.7015L13.4646 21.6522C13.0968 22.0696 12.4505 22.1182 12.0211 21.7607C11.5917 21.4032 11.5416 20.775 11.9094 20.3577C11.9437 20.3187 11.9811 20.2824 12.0211 20.2491L20.5081 11.9901H1.02374C0.45838 11.9901 0 11.5445 0 10.995C0 10.4454 0.45838 9.99992 1.02374 9.99992H20.5081L12.0211 1.75086C11.5917 1.39341 11.5416 0.765228 11.9094 0.347837C12.2773 -0.0695534 12.9235 -0.11821 13.3529 0.239323C13.393 0.272673 13.4304 0.308929 13.4646 0.347837L23.7024 10.2985C24.0992 10.6865 24.0992 11.3133 23.7023 11.7015Z"
                    fill="currentColor" />
                </svg>
              </div>
            </div>
            <div className="slider-arrow arrow-right w-slider-arrow-right">
              <div className="button-arrow-icon w-embed">
                <svg width="24" height="22" viewBox="0 0 24 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path id="Vector"
                    d="M0.297737 10.2985L10.5354 0.347838C10.9032 -0.0695532 11.5495 -0.11821 11.9789 0.239322C12.4083 0.596768 12.4584 1.22495 12.0906 1.64234C12.0563 1.68125 12.0189 1.71759 11.9789 1.75086L3.49187 10.0099H22.9763C23.5416 10.0099 24 10.4555 24 11.005C24 11.5546 23.5416 12.0001 22.9763 12.0001H3.49187L11.9789 20.2491C12.4083 20.6066 12.4584 21.2348 12.0906 21.6522C11.7227 22.0696 11.0765 22.1182 10.6471 21.7607C10.607 21.7273 10.5696 21.6911 10.5354 21.6522L0.297649 11.7015C-0.0992317 11.3135 -0.0992317 10.6867 0.297737 10.2985Z"
                    fill="#currentColor" />
                </svg>
              </div>
            </div>
            <div className="slider-nav-none w-slider-nav w-round"></div>
          </div>
        </div>
      </div>

    </>
  )
}

export default Service